export default __webpack_public_path__ + "static/media/cut-planet 1.41e623fa.png";